import { Component } from '@angular/core';
import { SummaryCardsComponent } from 'src/app/shared/components/summary-cards/summary-cards.component';
import { PaInfoBlockComponent } from 'src/app/shared/ui-kit/pa-info-block/pa-info-block.component';
import { SummaryItem } from 'src/app/shared/models';

@Component({
  selector: 'app-summary-cards-view',
  standalone: true,
  imports: [SummaryCardsComponent, PaInfoBlockComponent],
  templateUrl: './summary-cards-view.component.html',
  styleUrls: ['./summary-cards-view.component.scss'],
})
export class SummaryCardsViewComponent {
  basicItems: SummaryItem[] = [
    {
      icon: 'pi-list-check',
      title: 'Всего задач',
      value: 42,
      type: 'number',
    },
    {
      icon: 'pi-wallet',
      title: 'К выплате',
      value: 125000,
      type: 'money',
    },
    {
      icon: 'pi-check-circle',
      title: 'Выполнено',
      value: 18,
      type: 'number',
    },
  ];

  extendedItems: SummaryItem[] = [
    {
      icon: 'pi-users',
      title: 'Активные сотрудники',
      value: 8,
      limit: 10,
      tooltip: 'Количество активных сотрудников из доступного лимита',
      type: 'number',
    },
    {
      icon: 'pi-box',
      title: 'ПВЗ в работе',
      value: 15,
      limit: 20,
      tooltip: 'Пункты выдачи, подключённые к текущему тарифу',
      type: 'number',
    },
    {
      icon: 'pi-wallet',
      title: 'Расход бюджета',
      value: 75000,
      limit: 100000,
      tooltip: 'Сумма начислений за текущий период',
      type: 'money',
    },
    {
      icon: 'pi-chart-line',
      title: 'Прогресс',
      value: 6,
      tooltip: 'Наведите, чтобы увидеть подсказку без лимита',
      type: 'number',
    },
  ];
}
